import {Coupon} from '../components/user/coupon';

export default function polyfillGoldenTicketCoupon(isGoldenTicket: boolean, coupon: Coupon) {
  if (!isGoldenTicket || coupon.type !== 'support_coupon')
    return coupon;

  return {
    ...coupon,
    type: 'golden_ticket',
  }
}